import { appConfig } from '@/services/config.service'
import Axios from 'axios'
import { authRequestInterceptor } from '../interceptors/auth.request'
import { authResponseInterceptor } from '../interceptors/auth.response'
import { activateSentryRequest, activateSentryResponse } from '../interceptors/sentry'

export const httpClient = Axios.create({
  baseURL: appConfig.VITE_LEEA_TG_API_URL,
  timeout: 20000
})

activateSentryRequest(httpClient)
activateSentryResponse(httpClient)
authRequestInterceptor.activate(httpClient)
authResponseInterceptor.activate(httpClient)
